import type { FC } from 'react'

import { Radio, RadioGroup } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'

type OnboardingTypeProps = {
  isEditable: boolean
  allowPrivateNumber: boolean
  allowSubscriptions: boolean
  allowSubscriptionOptOut: boolean
  isPrivateSubscription: boolean
}

export const OnboardingType: FC<OnboardingTypeProps> = ({
  isEditable,
  allowPrivateNumber,
  allowSubscriptions,
  allowSubscriptionOptOut,
  isPrivateSubscription,
}) => (
  <section>
    <h3>
      <Text id="Telefonnummer" />
    </h3>

    <RadioGroup id="isNewNumber">
      {allowSubscriptions && !isPrivateSubscription && (
        <Field name="isNewNumber">
          {({ field, form }: FieldProps) => (
            <Radio
              id="isNewNumber-true"
              label={<Text id="Jeg ønsker nytt nummer" />}
              marginBottom={16}
              isDisabled={!isEditable}
              onFieldChange={() => {
                if (!form.values.isCreditCheckAccepted) return
                form.setFieldValue('isCreditCheckAccepted', false)
                form.setFieldTouched('isCreditCheckAccepted', false)
              }}
              {...field}
              checked={field.value === true && !form.values.isPrivateNumber}
              onChange={() => {
                form.setFieldValue('isNewNumber', true)
                form.setFieldValue('isOptOutSubscription', false)
                form.setFieldValue('isPrivateNumber', false)
              }}
            />
          )}
        </Field>
      )}

      {allowSubscriptions && !isPrivateSubscription && (
        <Field name="isNewNumber">
          {({ field, meta, form }: FieldProps) => (
            <Radio
              id="isNewNumber-false"
              label={<Text id="Jeg ønsker å overføre et eksisterende nummer" />}
              marginBottom={16}
              isDisabled={!isEditable}
              error={meta.error}
              touched={meta.touched}
              {...field}
              checked={
                field.value === false &&
                !form.values.isPrivateNumber &&
                !form.values.isOptOutSubscription
              }
              onChange={() => {
                form.setFieldValue('isNewNumber', false)
                form.setFieldValue('isOptOutSubscription', false)
                form.setFieldValue('isPrivateNumber', false)
              }}
            />
          )}
        </Field>
      )}

      {allowPrivateNumber && (
        <Field name="isPrivateNumber">
          {({ field, meta, form }: FieldProps) => (
            <Radio
              id="isPrivateNumber"
              label={<Text id="Private number" />}
              marginBottom={16}
              isDisabled={!isEditable}
              error={meta.error}
              touched={meta.touched}
              {...field}
              checked={field.value === true && !form.values.isNewNumber}
              onChange={() => {
                form.setFieldValue('isNewNumber', false)
                form.setFieldValue('isOptOutSubscription', false)
                form.setFieldValue('isPrivateNumber', true)
              }}
            />
          )}
        </Field>
      )}

      {allowSubscriptionOptOut && (
        <Field name="isOptOutSubscription">
          {({ field, meta, form }: FieldProps) => (
            <Radio
              id="isOptOutSubscription"
              label={<Text id="No, thank you. (Mobile Opt-Out)" />}
              marginBottom={16}
              isDisabled={!isEditable}
              error={meta.error}
              touched={meta.touched}
              {...field}
              checked={field.value === true && !form.values.isNewNumber}
              onChange={() => {
                form.setFieldValue('isNewNumber', false)
                form.setFieldValue('isPrivateNumber', false)
                form.setFieldValue('isOptOutSubscription', true)
              }}
            />
          )}
        </Field>
      )}
    </RadioGroup>
  </section>
)
